import {
  debounce
} from 'lodash';
import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

const minicartDrawer = document.querySelector('#CartDrawer');
const initMinicart = () => {
  if (!minicartDrawer) return;

  const closeBtn = minicartDrawer.querySelector('.minicart__close');
  if (closeBtn) closeBtn.addEventListener('click', () => closeMinicart());

  document
    .querySelectorAll('#PageContainer, #header')
    .forEach((backdropPlaceholder) =>
      backdropPlaceholder.addEventListener('click', closeMinicart),
    );

  minicartDrawer.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMinicart();
  });

  loadMinicart();
};

const lineUpdate = (productRow, lineIndex, quantity) => {
  productRow.classList.add('loading');
  ShopifyAPI.changeItem(
    lineIndex,
    quantity,
    () => {
      loadMinicart();
    },
    (XMLHttpRequest, textStatus) => {
      productRow.classList.remove('loading');
      const errorWrapper = productRow.querySelector('.minicart__product-error');
      if (errorWrapper && XMLHttpRequest ? .responseJSON ? .description) {
        errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
        errorWrapper.classList.remove('hidden');
        setTimeout(() => {
          errorWrapper.classList.add('hidden');
        }, 3000);
      }
    },
  );
};

const initQtyButtons = () => {
  if (!minicartDrawer) return;
  minicartDrawer
    .querySelectorAll('.minicart__product[data-line-index]')
    .forEach((productRow) => {
      const lineIndex = productRow.dataset.lineIndex;
      const qtyContainer = productRow.querySelector('.minicart__product-qty');
      if (qtyContainer) {

        const qtyInput = qtyContainer.querySelector(
          '.minicart__product-qty-value',
        );

        if (qtyInput) {
          const stock =
            qtyInput ? .dataset ? .stock >= 0 ? qtyInput.dataset.stock : -1;

          qtyInput.addEventListener('change', (e) => {
            const newValue = parseInt(qtyInput.value);
            if (stock >= 0) {
              if (stock >= newValue) {
                lineUpdate(productRow, lineIndex, newValue);
              }
            } else {
              lineUpdate(productRow, lineIndex, newValue);
            }
          });
        }
      }

      const removeLink = productRow.querySelector('a.minicart__product-remove');
      if (removeLink && removeLink.href) {
        removeLink.addEventListener('click', (e) => {
          e.preventDefault();
          lineUpdate(productRow, lineIndex, 0);
        });
      }
    });
};

const loadMinicart = async () => {
  if (!minicartDrawer) return;
  await fetch(`${Shopify.routes.root}cart?view=minicart`)
    .then(async (res) => res.text())
    .then(async (data) => {
      const minicartDom = new DOMParser().parseFromString(data, 'text/html');
      const minicartContent = minicartDom.querySelector('#MinicartContent');
      const minicartDrawerContent =
        minicartDrawer.querySelector('.minicart__content');
      if (minicartContent && minicartDrawerContent) {
        minicartDrawerContent.innerHTML = minicartContent.innerHTML;
      }
      if (window.Shopify && window.ShopifyAPI) {
        await fetch(`${window.Shopify.routes.root}cart.js`)
          .then(async (res) => res.json())
          .then(async (data) => {
            window.ShopifyAPI.updateCartItemsCount(data)
          });

      }
    });

  const form = minicartDrawer.querySelector('form');
  if (!form) return;
  $(form).parsley();

  initQtyButtons();
};

const openMinicart = () => {
  if (
    !minicartDrawer ||
    document.querySelector('html').classList.contains('template-cart')
  ) {
    return;
  }

  minicartDrawer.classList.add('minicart__drawer--open');
  minicartDrawer.focus();
  atQuery('min', 'md', () => {
    showBackdrop();
  });
};

const closeMinicart = () => {
  if (!minicartDrawer) return;
  atQuery('min', 'md', () => {
    if (minicartDrawer.classList.contains('minicart__drawer--open')) {
      hideBackdrop();
    }
  });
  minicartDrawer.classList.remove('minicart__drawer--open');
  minicartDrawer.blur();
};

export {
  initMinicart,
  openMinicart,
  closeMinicart,
  loadMinicart
};
